import SHAREBOX_S32_CHECK_OUT_STEPS from './s32';

const SHAREBOX_M28_CHECK_OUT_STEPS = SHAREBOX_S32_CHECK_OUT_STEPS;

export default SHAREBOX_M28_CHECK_OUT_STEPS;
